import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import BaseLayoutPromo from './BaseLayoutPromo';
import { LightDiskButton } from './fromAuth/LightDiskButton/LightDiskButton';
import { LightNavBar } from './fromAuth/LightNavBar/LightNavBar';
import media from '../../../theme/media';

export const Container = styled.div`
    padding: ${(props) => (props.hasBottomPanel ? '72px 24px 128px 24px' : '72px 24px 48px 24px')};
    margin: 0 auto;
    /* content width 480 */
    max-width: 528px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1;

    ${media.tablet720} {
        padding: 128px 24px;
        /* content width 504px */
        max-width: 552px;
    }

    & > form {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
`;

export const CommonPagePromo = (props) => {
    const setNavBarAlign = () => {
        if (props.rightHeaderComponent && props.backUrl) {
            return 'space-between';
        } else if (props.backUrl) {
            return 'left';
        } else {
            return 'right';
        }
    };

    return (
        <BaseLayoutPromo showPromoBanner={props.showPromoBanner}>
            <Container hasBottomPanel={props.hasBottomPanel}>{props.children}</Container>
            {(props.backUrl || props.rightHeaderComponent) && (
                <LightNavBar align={setNavBarAlign()}>
                    {props.backUrl && (
                        <LightDiskButton
                            type={props.type}
                            to={props.backUrl}
                            href={props.backUrl}
                            onClick={props.onClickIcon}
                            iconName={props.leftCloseIcon ? 'cross' : 'arrow-back'}
                            id={props.buttonId}
                            useThemeColor={props.useThemeColor}
                        />
                    )}
                    {props.rightHeaderComponent}
                </LightNavBar>
            )}
        </BaseLayoutPromo>
    );
};

CommonPagePromo.propTypes = {
    showPromoBanner: PropTypes.bool,
    backUrl: PropTypes.string,
    leftCloseIcon: PropTypes.bool, // если нужен крестик слева
    rightHeaderComponent: PropTypes.object,
    hasBottomPanel: PropTypes.bool, // если внизу на странице есть панель с кнопкой
    onClickIcon: PropTypes.func,
    isTagA: PropTypes.bool,
};
